module.exports = __webpack_public_path__ + "static/img/Consulting02.545a16f7.png";